import type { LatLng, StationPoint } from '@/shared/types/coords.schema';

const roundCoord = (coord: number): number => Math.round(coord * 1000) / 1000;

export const roundLatLng = (
	latLng?: LatLng | null,
): [number, number] | [null, null] => {
	if (!latLng) return [null, null];

	return [roundCoord(latLng.lat), roundCoord(latLng.lng)];
};

export const toStationPoint = (
	id?: string,
	coords?: { x: number; y: number },
): StationPoint | null => {
	if (!id || !coords) return null;

	return {
		id,
		lat: coords.y,
		lng: coords.x,
	};
};

export default roundCoord;
